import React, { useState, useEffect } from 'react';
import SwitchCoin from "./components/SwitchCoin";
import InputBet from "./components/InputBet";
import { BigNumber, ethers } from "ethers";
import {
  getCoinFlipMachineEggpAddress,
  getCoinFlipMachineCakeAddress,
  getCoinFlipMachineBUSDAddress,
  getCoinFlipTokenEprtAddress,
  getCoinFlipTokenEggpAddress,
  getCoinFlipTokenCakeAddress,
  getCoinFlipTokenBUSDAddress
} from "../../modules/addressHelpers";
import { Modal } from 'react-bootstrap';
import 'react-notifications-component/dist/theme.css';
import { store } from 'react-notifications-component';
import "./CoinFlip.scss";
import machineAbi from "../../config/abi/coinFlipMachine.json";
import * as  tokenAbi from "../../config/abi/BUSDABI.json";
import eggpBG from "../../assets/images/coin_eggp_bg.png";
import busdBG from "../../assets/images/coin_busd_bg.png";
import cakeBG from "../../assets/images/coin_cake_bg.png";
import metamaskLogo from '../../assets/images/metamask-fox.svg';
import infoIcon from "../../assets/images/info.svg";

const CoinFip = () => {
  const [coinClass, setCoinClass] = useState({
    coin1: '',
    coin2: '',
    coin3: ''
  });

  const [betInfo, setBetInfo] = useState({
    coin_status1: true, // true is for heads and false is for tails
    coin_status2: true,
    coin_status3: true,
    betType: 'eggp', // type is eggp or cake
    betAmount: 0,
    betMin: 0,
    betMax: 0,
    maxWin: 0,
    gameRound: 0,
    increment: 1
  });

  const [userInfo, setUserInfo] = useState({
    connected: false,
    provider: '',
    signer: '',
    wallet: '',
    balance: 0,
    coinflipBalance: 0,
    totalWin: 0,
    myWin: 0
  });

  const [contractInfo, setContractInfo] = useState({
    machineAddress: '',
    tokenAddress: '',
    machineAbi: '',
    tokenAbi: '',
    machineContract: '',
    tokenContract: ''
  });

  const [isApproved, setIsApproved] = useState(false);
  const [isSpined, setIsSpined] = useState(false);
  const [isReseted, setIsReseted] = useState(false);
  const [showModal, setShowModal] = useState(false);


  const [styles, setstyles] = useState({

    panel: {
        //backgroundImage:  `url(${eggpBG})`

      backgroundImage: `url(${betInfo.betType == "eggp" ? eggpBG : busdBG})`
    },
    infoStatus : {
       //backgroundColor: "#c99bff"
      backgroundColor: betInfo.betType == "eggp" ? "#c99bff" : "#5eb12b"
    }
  })

  useEffect(() => {
    let machineAddress, tokenAddress;

    if(betInfo.betType == 'eggp') {
      machineAddress = getCoinFlipMachineEggpAddress();
      tokenAddress = getCoinFlipTokenEggpAddress();

    }
    if(betInfo.betType == 'cake') {
      machineAddress = getCoinFlipMachineCakeAddress();
      tokenAddress = getCoinFlipTokenCakeAddress();
    }
    if(betInfo.betType == 'busd') {
      machineAddress = getCoinFlipMachineBUSDAddress();
      tokenAddress = getCoinFlipTokenBUSDAddress();
    }

    setContractInfo(prevState => ({
      ...prevState,
      machineAddress: machineAddress,
      tokenAddress: tokenAddress,
      machineAbi: machineAbi,
      tokenAbi: tokenAbi.abi
    }));
  }, []);

  const connectMetaMask = async () => {
    await window.ethereum.enable()
    let provider = new ethers.providers.Web3Provider(window.ethereum)
    let signer = provider.getSigner();
    let wallet = await signer.getAddress()

    setUserInfo(prevState => ({
      ...prevState,
      connected: true,
      provider: provider,
      signer: signer,
      wallet: wallet
    }));

    setMachineData(provider, signer, wallet);
  }

  const setMachineData = async (provider, signer, wallet) => {
    let machineContract = '';
    let tokenContract = '';

    machineContract = (new ethers.Contract(contractInfo.machineAddress, contractInfo.machineAbi, provider)).connect(signer);
    tokenContract = (new ethers.Contract(contractInfo.tokenAddress, contractInfo.tokenAbi, provider)).connect(signer);

    let allowance = BigNumber.from(await tokenContract.allowance(wallet, getCoinFlipMachineCakeAddress()));
    allowance = Math.round(ethers.utils.formatUnits(allowance)* 100) / 100;
    if(wallet && allowance > 0) {
      setIsApproved(true);
    }
    // this.getSlotViews();
    setContractInfo(prevState => ({
      ...prevState,
      machineContract: machineContract,
      tokenContract: tokenContract
    }));

    getGameInfo(machineContract, tokenContract, signer, wallet);
  }

  const getGameInfo = async (machineContract, tokenContract, signer, wallet) => {


    let balance  = BigNumber.from(await tokenContract.balanceOf(await signer.getAddress()));
    balance      = Math.round(ethers.utils.formatUnits(balance)* 100) / 100;
    let myWin    =  BigNumber.from(await machineContract.checkWinner(0, wallet));
    let totalWin = BigNumber.from(await machineContract.winCounter());
    totalWin     = ethers.utils.formatUnits(totalWin)*10**18;
    myWin        = ethers.utils.formatUnits(myWin);

    let coinflipId      = BigNumber.from(await machineContract.coinflipId());
    let minBet          = BigNumber.from(await machineContract.minBet());
    let maxBet          = BigNumber.from(await machineContract.maxBet());
    let coinflipBalance = BigNumber.from(await machineContract.coinflipBalance());
    let mainPrizePot    = BigNumber.from(await machineContract.mainPrizePot());


    coinflipId = Math.round ((ethers.utils.formatUnits(coinflipId))* 10**18);
    minBet = ethers.utils.formatUnits(minBet);
    maxBet = ethers.utils.formatUnits(maxBet);
    coinflipBalance = Math.round(ethers.utils.formatUnits(coinflipBalance)*100)/100;
    mainPrizePot = ethers.utils.formatUnits(mainPrizePot);

    setUserInfo(prevState => ({
      ...prevState,
      balance: balance,
      coinflipBalance: coinflipBalance,
      totalWin: totalWin,
      myWin: myWin
    }));

    setBetInfo(prevState => ({
      ...prevState,
      betAmount: minBet,
      betMin: minBet,
      betMax: maxBet,
      maxWin: mainPrizePot,
      gameRound: coinflipId
    }));
  }

  const approveEventHandler = () => {
    contractInfo.tokenContract.approve(contractInfo.machineAddress, ethers.constants.MaxUint256).then((re) => {
      setIsApproved(true);
    });
  }

  const Coin = (props) => {
    return (
      <div className={`coin ${props.cla}`}>
        <div className={`heads ${betInfo.betType}`}></div>
        <div className={`tails ${betInfo.betType}`}></div>
      </div>
    )
  }

  const chooseTokenHandler = (arg) => {
  let machineAddress, tokenAddress, bgImg, bgCol;
    setBetInfo(prevState => ({
      ...prevState,
      betType: arg
    }));

    let increment = 0;
    if(arg == 'eggp') {
      machineAddress = getCoinFlipMachineEggpAddress();
      tokenAddress = getCoinFlipTokenEggpAddress();
      increment= 1;
      bgImg =  `url(${eggpBG})` ;
      bgCol =  "#c99bff" ;
    }
    if (arg == 'cake'){
      machineAddress = getCoinFlipMachineCakeAddress();
      tokenAddress = getCoinFlipTokenCakeAddress();
      increment= 0.1;
      bgImg =  `url(${cakeBG})` ;
      bgCol = "#5eb12b" ;
    }
    if (arg == 'busd'){
      machineAddress = getCoinFlipMachineBUSDAddress();
      tokenAddress = getCoinFlipTokenBUSDAddress();
      bgImg = `url(${busdBG})`;
      bgCol = "#5eb12b";
    }
    console.log(bgImg);
    setstyles ( {
      panel: {  backgroundImage: bgImg  },
      infoStatus : { backgroundColor: bgCol }
    });

    setContractInfo(prevState => ({
      ...prevState,
      machineAddress: machineAddress,
      tokenAddress: tokenAddress
    }));
    let machineContract = (new ethers.Contract(machineAddress, contractInfo.machineAbi, userInfo.provider)).connect(userInfo.signer);
    let tokenContract = (new ethers.Contract(tokenAddress, contractInfo.tokenAbi, userInfo.provider)).connect(userInfo.signer);

    setContractInfo(prevState => ({
      ...prevState,
      machineContract: machineContract,
      tokenContract: tokenContract
    }));


    setBetInfo(prevState => ({...prevState,increment: increment}));
    if(userInfo.connected) {
      getGameInfo(machineContract, tokenContract, userInfo.signer, userInfo.wallet);
    }
  }

  const switchEventHandler = (e) => {
    const status_name = 'coin_status' + e.target.name;
    const status = !betInfo[status_name];
    setBetInfo(prevState => ({
      ...prevState,
      [status_name]: status
    }));
  }

  const betChangeEventHandler = (e) => {
    const val = parseFloat(e.target.value).toFixed(1);

    setBetInfo(prevState => ({
      ...prevState,
      betAmount: val
    }));
  }

  const betClickEventHandler = (s) => {
    let val = 0;
    let autobets = 0;
    switch (s) {
      case 'mins':
        if(betInfo.betAmount > betInfo.betMin) {
          val = parseFloat(betInfo.betAmount) - parseFloat(betInfo.increment) ;
        } else {
          val = parseFloat(betInfo.betMin);
        }
        break;
      case 'plus':
        if(betInfo.betAmount < betInfo.betMax*10000) {
          val = parseFloat(betInfo.betAmount) + parseFloat(betInfo.increment);
        } else {
          val = parseFloat(betInfo.betMax);
        }
        break;
      case 'max':
        val = betInfo.betMax;
        autobets = 1;
        break;
      case 'min':
        val = betInfo.betMin;
        autobets = 1;
        break;
      default:
        break;
    }

    setBetInfo(prevState => ({
      ...prevState,
      betAmount: parseFloat(val).toFixed(2)
    }));

    if (autobets ==1 ){
      spinEventHandler();
    }

  }

  const spinEventHandler = async () => {
    let bigNumberBet = await (ethers.utils.parseEther(betInfo.betAmount.toString()));
    let getfee =  BigNumber.from(await contractInfo.machineContract.getfee());
    getfee     = ethers.utils.formatUnits(getfee).toString();
    let overrides = {value: ethers.utils.parseEther(getfee) };
    let userGuess = createUserGuess();
    contractInfo.machineContract.playCoinFlip(bigNumberBet, userGuess, overrides).then(re => {
      displayNotification('The transaction is in process.');
    });
    let spinning = false;

    contractInfo.machineContract.on("RNG", (value) => {
      if(!spinning &&  value.toNumber().toString().length == 3) {
        setIsSpined(true);
        spinning = true;
        let retrievedNumber = value.toNumber().toString();

        let n1 = parseInt(retrievedNumber.substring(0,1));
        let n2 = parseInt(retrievedNumber.substring(1,2));
        let n3 = parseInt(retrievedNumber.substring(2,3));
        let animate_coin1 = n1 == '1' ? 'animate-heads' : 'animate-tails';
        let animate_coin2 = n2 == '1' ? 'animate-heads' : 'animate-tails';
        let animate_coin3 = n3 == '1' ? 'animate-heads' : 'animate-tails';

        setCoinClass({
          coin1: animate_coin1,
          coin2: animate_coin2,
          coin3: animate_coin3
        });

        setTimeout(() => {
          setCoinClass({
            coin1: animate_coin1 + ' animate-none',
            coin2: animate_coin2 + ' animate-none',
            coin3: animate_coin3 + ' animate-none'
          });
          setIsReseted(true);
          getGameInfo(contractInfo.machineContract, contractInfo.tokenContract, userInfo.signer, userInfo.wallet);
        }, 8000);
      }
    });
  }

  const createUserGuess = () => {
    const status1 = betInfo.coin_status1 ? 1 : 2;
    const status2 = betInfo.coin_status2 ? 1 : 2;
    const status3 = betInfo.coin_status3 ? 1 : 2;

    let num = status1 * 100 + status2 * 10 + status3
    return status1 * 100 + status2 * 10 + status3;
  }

  const resetEventHandler = () => {
    setIsSpined(false);

    setCoinClass({
      coin1: '',
      coin2: '',
      coin3: ''
    });

    setBetInfo(prevState => ({
      ...prevState,
      coin_status1: true,
      coin_status2: true,
      coin_status3: true,
      betAmount: betInfo.minBet
    }));
  }

  const claimEventHandler = async () => {
    let claim = await contractInfo.machineContract.claimPrizes(userInfo.wallet);
    getGameInfo(contractInfo.machineContract, contractInfo.tokenContract, userInfo.signer, userInfo.wallet);
  }

  const SpinResetButton = () => {
    return !isSpined ? (
      <div
        className="btn btn-primary btn-spin"
        onClick={spinEventHandler}
      >
        Spin
      </div>
    ) : (
      <div
        className={`btn btn-dark btn-spin ${!isReseted && "disabled"}`}
        onClick={resetEventHandler}
      >
        Reset
      </div>
    )
  }

  const modalShowEventHandler = () => {
    setShowModal(true);
  }

  const modalCloseEventHandler = () => {
    setShowModal(false);
  }

  const displayNotification = (m) => {
    store.addNotification({
      title: "",
      message: m,
      type: "success",
      insert: "top",
      container: "top-center",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
          duration: 10000,
          onScreen: true,
          showIcon: true,
      }
    });
  }

  return (
    <div className="container">
      <div className="content coinflip-panel">
        <div className="connect-wallet mb-3 text-center">
          {!userInfo.connected ? (
            <button className="btn btn-success" onClick={connectMetaMask}>
              <img src={metamaskLogo} width="20px"/> Connect
            </button>
          ) : (
            <div>

            </div>
          )}
        </div>
        <div className="choose-token">
          <div
            className="btn-bet token-eggp"
            onClick={() => chooseTokenHandler('eggp') }
          >
            EGGP
          </div>
          <div
            className="btn-bet token-busd"
            onClick={() => chooseTokenHandler('busd')}
          >
            BUSD
          </div>
          <div
            className="btn-bet token-cake"
            onClick={() => chooseTokenHandler('cake')}
          >
            CAKE
          </div>

        </div>
        <div style={styles.panel} className="table-fac">
          <div className="coin-content">
            <div className="comment-panel comment-left">
              Game Balance: {userInfo.coinflipBalance}
            </div>
            <div className="comment-panel comment-right">
              My Winnings: {userInfo.myWin}
            </div>
            <div className="coin-panel">
              1<Coin cla={coinClass.coin1}/>
              2<Coin cla={coinClass.coin2}/>
              3<Coin cla={coinClass.coin3}/>
            </div>
            <div className="row coin-middle">
              <div className="col-6">
                <div className="info-item">
                  <label>Max Win: {betInfo.maxWin}</label>
                </div>
                <div className="info-item">
                  <label>Max Bet: {betInfo.betMax}</label>
                </div>
                <div className="info-item">
                  <label>Min Bet: {betInfo.betMin}</label>
                </div>
                <div className="info-item">
                  <label>Win Count: {userInfo.totalWin}</label>
                </div>
              </div>
              <div className="col-6 switch-items">
                <SwitchCoin
                  num="1"
                  status={betInfo.coin_status1}
                  change={switchEventHandler}
                  isSpined={isSpined}
                  betType={betInfo.betType}
                />
                <SwitchCoin
                  num="2"
                  status={betInfo.coin_status2}
                  change={switchEventHandler}
                  isSpined={isSpined}
                  betType={betInfo.betType}
                />
                <SwitchCoin
                  num="3"
                  status={betInfo.coin_status3}
                  change={switchEventHandler}
                  isSpined={isSpined}
                  betType={betInfo.betType}
                />
              </div>
            </div>
            <div className="coin-input-bet">
              <InputBet
                amount={betInfo.betAmount}
                change={betChangeEventHandler}
                click={betClickEventHandler}
                isSpined={isSpined}
              />
              <img className="coin-info" style={styles.infoStatus}  src={infoIcon} onClick={modalShowEventHandler}/>
            </div>
            {userInfo.connected && (
              <div className="d-flex justify-content-center coin-footer">
                {
                  !isApproved ? (
                    <div
                      className="btn btn-success btn-spin"
                      onClick={approveEventHandler}
                    >
                      <img src={metamaskLogo} width="20px"/> Approve
                    </div>
                  ) : (
                    <>
                      <SpinResetButton/>
                      <div
                        className={`btn btn-success btn-claim ${(isSpined || userInfo.coinflipBalance == 0) && "disabled"}`}
                        onClick={claimEventHandler}
                      >
                        Claim
                      </div>
                    </>
                  )
                }
              </div>
            )}
          </div>
        </div>
      </div>
      <Modal
        show={showModal}
        onHide={modalCloseEventHandler}
        centered
      >
        <div className="position-relative text-right modal-close-area">
          <button type='button' className="btn-modal-close" onClick={modalCloseEventHandler} onKeyDown={modalCloseEventHandler}> </button>
        </div>
        <div className="modal-text">
        Welcome to the <b>Eggplant Finance CoinFlip Game (BETA)!</b>  🍆 <br/><br/>
        Want your chance to win 5x in a single transaction? Select the 3 coins and flip to see if you can guess the correct outcome!<br/><br/>
        <i>NB: We are currently beta testing our games, if you have any issues please contact us via <a href="https://t.me/eggplant_fi"> our telegram</a>.</i>
        </div>
      </Modal>
    </div>
  )
};

export default CoinFip;
